define('SearchAutocompleteComponent',[
  "AutocompleteComponent",
  "SearchFieldObservable",
], function (AutocompleteComponent, SearchFieldObservable) {
  /**
   * Creates a NewHomeSource search autocomplete component
   * @class
   * @extends AutocompleteComponent
   * @param {HTMLElement} context Element context
   */
  function SearchAutocompleteComponent(context) {
    AutocompleteComponent.call(this, context, new SearchFieldObservable(context.querySelector("[data-component-rol=target-input]"))); // Call base class constructor
    /**
     * @property {Boolean} dependeciesRequested Flag to know if the dependencies were already requested
     */
    this.dependeciesRequested = false;
    this.includeCurrentLocation = context.hasAttribute("data-component-includeCurrentLocation");
    this.includeCurrentLocationIcon = context.hasAttribute("data-component-include-current-location-icon");
    this.includeHighlightInSuggestion = !context.hasAttribute("data-exclude-highlight");
    Object.defineProperty(this, "isCurrentLocation", {
      get: (function () {
        return this._currentLocationSuggestion && this._currentLocationSuggestion === this.value;
      }).bind(this)
    });

    this.onSelect = null;
  }
  SearchAutocompleteComponent.prototype = Object.create(AutocompleteComponent.prototype, {
    constructor: {
      value: SearchAutocompleteComponent
    }
  });

  /**
   * Loads the dependencies
   * @method
   * @param {Function} callback Callback to execute when the dependencies are loaded
   */
  SearchAutocompleteComponent.prototype._loadDependencies = function (callback) {
    // If the dependencies hasn't been requested yet call them
    if (!this.dependeciesRequested) {
      require([
        "SuggestionsEngineConfig",
        "SearchSuggestionsEngine",
        "SearchSuggestionsComponent",
        "SearchSuggestion"
      ], (function (SuggestionsEngineConfig, SearchSuggestionsEngine, SearchSuggestionsComponent, SearchSuggestion) {
        this._engine = new SearchSuggestionsEngine(new SuggestionsEngineConfig());
        this._suggestionsComponent = new SearchSuggestionsComponent(this._searchField);
        if (this.includeCurrentLocation) {
          this._currentLocationSuggestion = new SearchSuggestion({ id: 0, name: "Current Location", cssClass: "currentLocationSuggestion nhs-c-suggestion nhs-c-suggestion--icon", dataAttributes: ["data-current-location"],
            icon: this.includeCurrentLocationIcon ? `<div class='nhs-c-suggestion__icon-container'><svg width='14' height='14' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M7.5 0v1.522A5.502 5.502 0 0 1 12.478 6.5H14v1h-1.522A5.502 5.502 0 0 1 7.5 12.478V14h-1v-1.522A5.502 5.502 0 0 1 1.522 7.5H0v-1h1.522A5.502 5.502 0 0 1 6.5 1.522V0h1Zm-5 7a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm3 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM7 4.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z' fill='currentColor'/></svg></div>` : null
           });
        }
        this._suggestionsComponent.onSelect = this._onSelect.bind(this);
        callback();
      }).bind(this));
      this.dependeciesRequested = true; // Let me know that even when the dependencies are not loaded yet I've requested them to avoid doing it twice
    } else if (this._suggestionsComponent && this._engine) { // If the dependencies are there run the funcion
      callback();
    }
  };

  SearchAutocompleteComponent.prototype._onSelect = function () {
    if (this.onSelect instanceof Function) {
      this.onSelect();
    }
  };

  /**
   * removeCurrentLocation: removes the current location option from the component and sets the include current location flag to false
   * in order to avoid showing the current location option in further typeahead interactions.
   * @method
   */
  SearchAutocompleteComponent.prototype.removeCurrentLocation = function () {
    const currentLocationOption = this._suggestionsComponent.htmlElement.querySelector('[data-current-location]');

    if (!currentLocationOption) {
      return;
    }

    this.includeCurrentLocation = false;
    currentLocationOption.remove();
  };

  /**
   * Updates the Autocomplete Suggestions
   * @method
   * @param {Function} callback Callback
   */
  SearchAutocompleteComponent.prototype.update = function (callback) {
    this._loadDependencies((function () {
      AutocompleteComponent.prototype.update.call(this, callback); // Call the base implementation
    }).bind(this));
  };

  SearchAutocompleteComponent.prototype.displaySuggestions = function () {
    if (this.includeCurrentLocation) {
      this.suggestions.unshift(this._currentLocationSuggestion);
    }
    AutocompleteComponent.prototype.displaySuggestions.call(this);
  };

  SearchAutocompleteComponent.prototype.selectSuggestion = function (index) {
    AutocompleteComponent.prototype.selectSuggestion.call(this, index);
    this._searchField.setAttribute("data-suggestion-index", index);
  };

  /**
   * Auto initializes all the components in the page
   * @method
   * @static
   */
  SearchAutocompleteComponent.initAll = function () {
    var searchAutocompleteComponents = document.querySelectorAll("[data-component=search-autocomplete]");
    for (var i = 0; i < searchAutocompleteComponents.length; i++) {
      if (!searchAutocompleteComponents[i].searchAutocompleteComponent) {
        searchAutocompleteComponents[i].searchAutocompleteComponent = new SearchAutocompleteComponent(searchAutocompleteComponents[i]);
      }
    }
  };
  SearchAutocompleteComponent.initAll();
  return SearchAutocompleteComponent;
});
/**
 * Made with ♥ by NewHomeSource's team
 * Copyright (c) 2019-present, BuilderHomeSite Inc. All rights reserved.
 */;
